import { useMutation } from '@tanstack/react-query';
import { createResourceHooks } from '@repo/api-client';
import { auditClient, exportAuditEvents } from './network';
import { type AuditEventListItem, type AuditEventDetail } from './types';

export const auditHooks = createResourceHooks<
  AuditEventListItem,
  AuditEventDetail,
  any,
  any
>(auditClient as any, ['audit', 'events']);

export function useExportAuditEvents() {
  return useMutation({
    mutationFn: (params: Record<string, string | number>) => exportAuditEvents(params),
  });
}
